// Detail page variables for log events paging
var firstIndex = 0;
var lastIndex = 5;


function serializeComment(node, isLastNode = false) {
    console.log(node)
    /* NOTE: This serializer is AI generated. */
    if (node.hasOwnProperty('type')) {
        if (node.type === 'mention') {
            return `@${node.name}`;
        }
        if (node.type === 'paragraph') {
            const content = node.children.map(child => serializeComment(child)).join('');
            const lastChild = node.children[node.children.length - 1];
            const endsWithEmptyText = (!lastChild.hasOwnProperty('type') || lastChild.type === 'text') && lastChild.text === '';
            // Add br if paragraph is empty or ends with empty text, but not if it's the last node
            if ((content === '' || endsWithEmptyText) && !isLastNode) {
                return content + '<br/>';
            }
            return content;
        }
    }
    if (!node.hasOwnProperty('type') || node.type === 'text') {
        return node.text
    }
    return '';
};



function loadMore() {

    var logTableHtml = "";
    if (lastIndex > logs.length) {
        $('#load-more-logs-button').addClass('uk-hidden');
        $('#load-more-logs-end').removeClass('uk-hidden');
    }

    slicedLogs = logs.slice(firstIndex, lastIndex);

    $.each(slicedLogs, function (i, log) {
        let logLabel = trans('status.running_again');
        let logDescription = null;
        let logIcon = "icon-arrow-up-circle";
        let verb = trans('common.was');

        if (i == 0 && firstIndex == 0) {
            verb = trans('common.is');
        }

        if (log.label == "down") {
            logLabel = trans('status.down_for').replace('%s', log.duration);
            logIcon = "icon-arrow-down-circle";
        } else if (log.label == "paused") {
            logLabel = trans('status.monitor_paused').replace('%s', verb);
            logIcon = "icon-pause-circle";
        } else if (log.label == "started") {
            logLabel = trans('status.monitor_started');
            logIcon = "icon-play-circle";
        } else if (log.class === 'comment') {
            const parsedCommentNodes = JSON.parse(log.comment);
            const serializedComment = parsedCommentNodes.map((node, index) => serializeComment(node, index === parsedCommentNodes.length - 1)).join('');

            logLabel = `Comment by ${log.authorName}`;
            logDescription = serializedComment
            logIcon = "icon-comment";
        }

        var animationClass = firstIndex != 0 ? ' uk-animation-slide-top-small' : '';

        logTableHtml += '<div class="psp-announcement psp-alert' + animationClass + '" data-ts="' + log.time + '"><div class="uk-flex uk-flex-top">';
        if (log.class === 'comment') {
            logTableHtml += `
            <svg class="psp-announcement-icon" fill="currentColor" viewBox="0 0 16 16" width="24" height="24">
                <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
                <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
            </svg>
            `
        } else { logTableHtml += '<svg class="psp-announcement-icon icon ' + logIcon + ' uk-flex-none"><use href="/assets/symbol-defs.svg#' + logIcon + '"></use></svg>'; }

        logTableHtml += '    <div class="uk-flex-auto">';
        logTableHtml += '        <h4 class="uk-margin-remove">' + logLabel + '</h4>';

        if (logDescription !== null) {
            logTableHtml += `<p style="font-size: 16px">${logDescription}</p>`;
        }

        if (log.label == "down" && log.reason.detail != null) {
            logTableHtml += '<p class="psp-alert-reason">The reason ' + verb + '  <strong>' + log.reason.detail.short + '</strong>.';
            if (log.reason.code.length <= 3) {
                logTableHtml += '<strong class="uk-label uk-label-danger">' + log.reason.code + '</strong>';
            }
            logTableHtml += '</p>';
            if (log.reason.detail.full !== undefined) {
                logTableHtml += '<p class="psp-alert-reason-detail uk-text-muted"><strong>' + trans('status.details') + ':</strong>' + log.reason.detail.full +'</p>';
            }
        }
        const localizedDate = formatLocalizedDateTime(log.dateGMT);
        logTableHtml += '        <p class="uk-text-muted font-14" uk-tooltip title="' + localizedDate + ' GMT">' + localizedDate + ' (' + window.timeZone + ')</p>';
        logTableHtml += '    </div>';
        logTableHtml += '</div></div>';
    });

    $('.event-table-wrapper').append(logTableHtml);

    step = lastIndex - firstIndex;
    firstIndex = lastIndex;
    lastIndex = lastIndex + step;
}

$(function () {

    /* Main script init */
    var cInt = setInterval(countdown, 1000);
    $('.last-updated').text(new Date().toLocaleTimeString());
    callMonitorDetail(true);
    /* END Main script init */

    $('#load-more-logs-button').on('click', function () {
        loadMore($('#load-more-logs-button').data('monitor-name'));
    });
});

function callMonitorDetail(callLog) {
    $.ajax({
        type: "GET",
        url: window.pspApiPath,
        dataType: "json",
        cache: false,
        retryLimit: 2,
        success: function (data) {

            var downCount = data.statistics.counts.down;
            var upCount = data.statistics.counts.up;
            var pausedCount = data.statistics.counts.paused;
            var totalCount = data.statistics.counts.total;

            $('#totalCount').text(totalCount);
            $('#upCount').text(upCount);
            $('#downCount').text(downCount);
            $('#pausedCount').text(pausedCount);

            $(".psp-main-status-dot").removeClass('is-grey is-error');

            if (upCount == 0 && pausedCount == 0) {
                $(".psp-main-status-dot").addClass('is-error');
            } else if (downCount != 0) {
                $(".psp-main-status-dot").addClass('is-warning');
                playAlertSound();
            } else if (pausedCount == totalCount) {
                $(".psp-main-status-dot").addClass('is-grey');
            }

            window.timeZone = data.timezone;

            $('title').text(data.monitor.name + ' - ' + data.title);

            $(".psp-main-status-wrap .psp-main-status-dot").removeClass('is-grey is-error');

            if (data.monitor.statusClass == "success") {
                $('.psp-main-status').html('<span class="uk-flex-inline psp-mon-detail-name"><span class="uk-display-inline-block">' + data.monitor.name + '</span></span> ' + trans('common.is') + ' <span class="uk-text-primary">' + trans('common.operational').toLowerCase() + '</span>');
            } else if (data.monitor.statusClass == "danger") {
                $(".psp-main-status-wrap .psp-main-status-dot").addClass('is-error');
                $('.psp-main-status').html(data.monitor.name + ' ' + trans('common.is') + ' <span class="uk-text-danger">' + trans('common.down').toLowerCase() + '</span>');
                playAlertSound();
            } else {
                $('.psp-main-status-wrap .psp-main-status-dot').addClass('is-grey');
                $('.psp-main-status').html(data.monitor.name + ' ' + trans('common.is') + ' <span class="uk-text-muted">' + trans('common.not_monitored') + '</span>');
            }

            var monitorType = data.monitor.type.charAt(0).toUpperCase() + data.monitor.type.slice(1);


            if (data.monitor.url === null) {
                $('.psp-monitor-interval').text(data.monitor.checkInterval);
            } else {
                var monitorURLhref = data.monitor.url;

                if (!data.monitor.url.startsWith('http')) {
                    monitorURLhref = "http://" + monitorURLhref;
                }

                var montiorUrl = data.monitor.url === null ? '' : ' ' + trans('common.for') + ' <a href="' + monitorURLhref + '" class="uk-text-truncate uk-display-inline-block" title="' + data.monitor.url + '">' + data.monitor.url + '</a>';

                $('.psp-monitor-interval').html(monitorType + ' ' + trans('common.monitoring') + montiorUrl + ', ' + data.monitor.checkInterval.toLowerCase());
            }



            // Generate status dot for monitor

            var statusDot = '';
            if (data.monitor.statusClass = "success") {
                statusDot = '<div class="uk-text-primary"><span class="dot is-pulse m-r-10" aria-hidden="true"></span>' + trans('common.operational') + '</div>';
            } else if (data.monitor.statusClass = "danger") {
                statusDot = '<div class="uk-text-danger"><span class="dot is-pulse is-error m-r-10" aria-hidden="true"></span>' + trans('common.down') + '</div>';
            } else {
                statusDot = '<div class="uk-text-muted"><span class="dot is-pulse is-grey m-r-10" aria-hidden="true"></span>' + trans('common.paused') + '</div>';
            }

            var bars = '';
            var days = data.days.reverse();
            var dailyData = data.monitor.dailyRatios.reverse();

            var w = window.innerWidth;

            var barLimit = 90;
            var svgW = window.compact ? 920 : 880;
            var svgH = window.compact ? 20 : 30;
            var barGap = window.compact ? 10.25 : 9.8;
            var barW = 6;

            if (w <= 768) {
                barLimit = 30;
                barGap = 19.8;
                barW = 12;
                svgW = 588;
                svgH = window.compact ? 30 : 60;
            }

            var startI = 90 - barLimit;

            // Generate bars for monitor
            for (var i = startI; i < 90; i++) {
                var daily = dailyData[i];
                var notMonitored = false;
                var d = new Date(days[i]).getTime() / 1000;
                var dataDisplayDay = daily.ratio + '%';

                if (d < data.monitor.createdAt - 86400) {
                    notMonitored = true;
                }

                /* set up a bar color based on value */
                var fillColor = "#3bd671"; // green color
                var fillOpacity = '1';

                if (notMonitored == true || daily.label == "black") {
                    fillColor = "#687790";
                    dataDisplayDay = trans('common.no_records');
                } else {
                    if (daily.ratio < 100 && daily.ratio >= 99) {
                        fillColor = "#3bd671"; // orange color
                        fillOpacity = '0.5';
                    } else if (daily.ratio < 99 && daily.ratio >= 95) {
                        fillColor = '#f29030'; // orange color
                    } else if (daily.ratio < 95) {
                        fillColor = '#df484a'; // red color
                    }
                }

                bars += '<rect height="' + svgH + '" width="' + barW + '" x="' + (i - startI) * barGap + '" y="0" fill="' + fillColor + '" fill-opacity="' + fillOpacity + '" rx="' + barW / 2 + '" ry="' + barW / 2 + '" uk-tooltip="<div class=\'uk-text-muted font-12\'>' + days[i] + '</div>\
                    ' + dataDisplayDay + '" />';
            }

            // Generate HTML for monitor row
            var monitorHtml = '\
                    <div class="psp-monitor-row">\
                        <div class="uk-flex uk-flex-between uk-flex-wrap uk-margin-small-bottom">\
                            <div class="uk-text-primary">\
                                <span class="uk-visible@s">' + data.monitor['90dRatio']['ratio'] + '%</span>\
                                <span class="uk-hidden@s">' + data.monitor['30dRatio']['ratio'] + '%</span>\
                            </div>\
                        </div>\
                        <div class="psp-charts">\
                            <div>\
                                <svg width="' + svgW + '" height="' + svgH + '" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + svgW + ' ' + svgH + '">\
                                ' + bars + '\
                                </svg>\
                            </div>\
                        </div>\
                    </div>';

            $('.psp-uptime-chart').html(monitorHtml);

            var pageUrl = DOMPurify.sanitize(window.location.href.replace(location.search, '').replace(/\/$/, ''));
            $('.psp-calendar-link').attr('href', pageUrl + '/calendar');

            if (data.monitor.type != "Heartbeat") {
                $('.rt-section').removeClass('uk-hidden');
            }

            var monitorName = data.monitor.name;

            // Fill overall statistic
            $('#overall-uptime div:nth-child(1) h3').text(data.monitor['1dRatio'].ratio + '%');
            $('#overall-uptime div:nth-child(2) h3').text(data.monitor['7dRatio'].ratio + '%');
            $('#overall-uptime div:nth-child(3) h3').text(data.monitor['30dRatio'].ratio + '%');
            $('#overall-uptime div:nth-child(4) h3').text(data.monitor['90dRatio'].ratio + '%');

            // Events

            logs = data.monitor.logs;

            if (callLog) {
                // This is called on detail page initial load
                loadMore();
            } else {
                // This will add new alert when some is added on refresh
                var logTableHtml;
                var lastRecordDate = $('.event-table-wrapper > div:first-child').data('ts');

                if (lastRecordDate) {
                    if (lastRecordDate < logs[0].time) {
                        $.each(logs, function (i, nLog) {
                            var logLabel = trans('status.running_again');
                            var logIcon = "icon-arrow-up-circle";

                            if (nLog.label == "down") {
                                logLabel = monitorName + " is down for " + nLog.duration;
                                logIcon = "icon-arrow-down-circle";
                            } else if (nLog.label == "paused") {
                                logLabel = trans('status.monitor_paused');
                                logIcon = "icon-pause-circle";
                            } else if (nLog.label == "started") {
                                logLabel = trans('status.monitor_started');
                                logIcon = "icon-play-circle";
                            } else if (nLog.label == "up") {
                            }


                            if (nLog.time > lastRecordDate) {
                                logTableHtml += '<div class="psp-announcement psp-alert" data-ts="' + nLog.time + '"><div class="uk-flex">';
                                logTableHtml += '<svg class="icon ' + logIcon + ' uk-flex-none"><use href="/assets/symbol-defs.svg#' + logIcon + '"></use></svg>';
                                logTableHtml += '    <div class="uk-flex-auto">';
                                logTableHtml += '        <h4 class="uk-margin-remove">' + logLabel + '</h4>';
                                logTableHtml += '        <div class="uk-label" uk-tooltip title="' + nLog.dateGMT + ' GMT">' + nLog.date + ' GMT ' + window.timeZone + '</div>';
                                if (nLog.label == "down" && nLog.reason.detail != null) {
                                    logTableHtml += '<p class="uk-text-muted psp-alert-reason">' + trans('status.log_reason') + ' <strong>' + nLog.reason.detail.short + '</strong> <strong class="uk-label uk-label-danger">' + nLog.reason.code + '</strong></p>';
                                    if (nLog.reason.detail.full !== undefined) {
                                        logTableHtml += '<p class="psp-alert-reason-detail uk-text-muted"><strong>Details:</strong> <em class="uk-text-muted">' + nLog.reason.detail.full + '</em></p>';
                                    }
                                }
                                logTableHtml += '    </div>';
                                logTableHtml += '</div></div>';
                            }
                        });
                        $('.event-table-wrapper').append(logTableHtml);
                    }
                }
            }


            // Monitor detail RT chart

            if (data.monitor.type != "Heartbeat") {
                var ctxLabels = [];
                var ctxDataWithMeta = [];
                var ctxData = [];

                var rtObj = data.monitor.responseTimes;

                if (rtObj.length > 0) {

                    $.each(rtObj, function (i, rt) {
                        ctxLabels.push(rt.datetime);
                        ctxDataWithMeta.push({ meta: rt.datetime, value: rt.value });
                        if (rt.value !== null)
                            ctxData.push(rt.value);
                    });

                    var high = Math.round(Math.max(...ctxData) / 100) * 100;
                    var highestRT = Math.max(...ctxData);
                    var lowestRT = Math.min(...ctxData);

                    if (rtObj.length > 1) {
                        var chart = new Chartist.Line('#chart-container', {
                            labels: ctxLabels,
                            series: [
                                ctxDataWithMeta
                            ]
                        }, {
                            showArea: true,
                            fullWidth: true,
                            showLabel: false,
                            chartPadding: {
                                top: 10,
                                left: 0,
                                bottom: 0,
                                right: 0
                            },
                            axisX: {
                                showLabel: false,
                                showGrid: false,
                            },
                            axisY: {
                                type: Chartist.FixedScaleAxis,
                                labelInterpolationFnc: function (value) {
                                    return value + 'ms';
                                },
                                offset: 0,
                                position: 'start',
                                onlyInteger: true,
                                labelOffset: {
                                    x: 0,
                                    y: 38
                                },
                                low: 0,
                                ticks: [high / 2]
                            },
                            lineSmooth: Chartist.Interpolation.cardinal({
                                tension: 5,
                                fillHoles: false
                            }),
                            plugins: [
                                Chartist.plugins.tooltip({
                                    anchorToPoint: true,
                                    date: true
                                })
                            ],
                        });

                        chart.on('draw', function (context) {
                            if (context.type === 'label') {
                                context.element.attr({
                                    width: '50px'
                                });
                            }
                            if (context.type === 'line' || context.type === 'area') {
                                context.element.animate({
                                    d: {
                                        begin: 1000 * context.index,
                                        dur: 1000,
                                        from: context.path.clone().scale(1, 0).translate(0, context.chartRect.height()).stringify(),
                                        to: context.path.clone().stringify(),
                                        easing: Chartist.Svg.Easing.easeOutQuint
                                    }
                                });
                            }
                            $('#chart-container [class*="psp-fake-"]').hide();
                        });

                    } else {
                        $('#chart-container').html('<div class="uk-text-center uk-text-muted uk-padding">' + trans('common.no_history') + '.</div>');
                    }

                } else {
                    $('#chart-container').html('<div class="uk-text-center uk-text-muted uk-padding">' + trans('common.no_history'));
                }

                var avgRT = ctxData.reduce(function (acc, val) { return acc + val; }, 0) / ctxData.length;
                $('#avg-rt').text(avgRT === undefined ? 'N/A' : avgRT.toFixed(2) + 'ms');
                $('#h-rt').text(highestRT === undefined ? 'N/A' : highestRT.toFixed(2) + 'ms');
                $('#l-rt').text(lowestRT === undefined ? 'N/A' : lowestRT.toFixed(2) + 'ms');
            }


            if (window.location.hash == "#logs" && callLog == true) {
                $('html, body').animate({
                    scrollTop: $("#logs").offset().top - 50
                }, 400);
            }

        },
        error: function (error) {
            console.log(error);
            /*
                        if (this.retryLimit > 0) {
                            //try again
                            $.ajax(this);
                            return;
                        } else {
                            //UIkit.modal('#error-modal').show();
                            return;
                        }
            
                        this.tryCount--;*/
        }
    });
}
